import React, { useState } from "react";

const DataTableHeader = () => {
  const [pageSize, setPageSize] = useState(10);
  const [globalFilter, setGlobalFilter] = useState("");
  const sizeOptions = [10, 25, 50, 100];

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
  };

  return (
    <div className="flex flex-col md:flex-row justify-between mb-2 text-dark space-y-2 md:space-y-0 text-dark">
      <div className="flex items-center">
        Show
        <select
          value={pageSize}
          onChange={handlePageSizeChange}
          name="tableselect"
          className="ml-2 bg-light rounded-lg py-1 px-2 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
        >
          {sizeOptions.map((size, index) => (
            <option key={index} value={size}>
              {size}
            </option>
          ))}
        </select>
        &nbsp;&nbsp;entries
      </div>
      <div className="flex md:items-center">
        <span className="sm:mr-2 mr-1">Search:</span>
        <input
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          name="tablesearch"
          className="ml-2 bg-light rounded-lg py-1 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
        />
      </div>
    </div>
  );
};

export default DataTableHeader;
